module.exports = __webpack_public_path__ + "static/media/theme_festive.840853ca.mp3";